function getProgressionType(flowType) {
  switch (flowType) {
    case "no-feedback":
      return "free";
    case "conditional":
      return "fixed";
    case "test-in-order":
    case "test-random":
    case "training-in-order":
    case "training-random":
      return "free";
  }
}

export { getProgressionType };
//# sourceMappingURL=util.get-progression-type.js.map
